"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QuickLRU_1 = __importDefault(require("../util/QuickLRU"));
const configuration_1 = require("../configuration");
class TextSearchManager {
    constructor(pluginManager) {
        this.pluginManager = pluginManager;
        this.adapterCache = new QuickLRU_1.default({
            maxSize: 15,
        });
    }
    /**
     * Instantiate/initialize list of relevant adapters
     */
    loadTextSearchAdapters(searchScope) {
        return this.relevantAdapters(searchScope).map(adapterConfig => {
            const adapterId = (0, configuration_1.readConfObject)(adapterConfig, 'textSearchAdapterId');
            if (this.adapterCache.has(adapterId)) {
                return this.adapterCache.get(adapterId);
            }
            else {
                const { AdapterClass } = this.pluginManager.getTextSearchAdapterType(adapterConfig.type);
                const adapter = new AdapterClass(adapterConfig, undefined, this.pluginManager);
                this.adapterCache.set(adapterId, adapter);
                return adapter;
            }
        });
    }
    /**
     * Returns list of relevant text search adapters to use
     * @param args - search options/arguments include: search query
     */
    relevantAdapters(searchScope) {
        var _a;
        const { aggregateTextSearchAdapters, tracks } = (_a = this.pluginManager.rootModel) === null || _a === void 0 ? void 0 : _a.jbrowse;
        const { assemblyName } = searchScope;
        const relevant = [
            ...this.getAdaptersWithAssembly(assemblyName, aggregateTextSearchAdapters),
            ...this.getTrackAdaptersWithAssembly(assemblyName, tracks),
        ];
        return relevant;
    }
    getAdaptersWithAssembly(asmName, adapterConfs) {
        return adapterConfs.filter(conf => { var _a; return (_a = (0, configuration_1.readConfObject)(conf, 'assemblyNames')) === null || _a === void 0 ? void 0 : _a.includes(asmName); });
    }
    getTrackAdaptersWithAssembly(asmName, adapterConfs) {
        const tracksConfs = adapterConfs.filter(conf => {
            var _a;
            return (_a = (0, configuration_1.readConfObject)(conf, [
                'textSearching',
                'textSearchAdapter',
                'assemblyNames',
            ])) === null || _a === void 0 ? void 0 : _a.includes(asmName);
        });
        const trackAdapters = tracksConfs.map(trackConf => {
            const { textSearching } = trackConf;
            const { textSearchAdapter } = textSearching;
            return textSearchAdapter;
        });
        return trackAdapters;
    }
    /**
     * Returns list of relevant results given a search query and options
     * @param args - search options/arguments include: search query
     * limit of results to return, searchType...prefix | full | exact", etc.
     */
    async search(args, searchScope, rankFn) {
        // determine list of relevant adapters based on scope
        const textSearchAdapters = this.loadTextSearchAdapters(searchScope);
        const results = await Promise.all(textSearchAdapters.map(adapter => adapter.searchIndex(args)));
        // aggregate and return relevant results
        return this.sortResults(results.flat(), rankFn);
    }
    /**
     * Returns array of revelevant and sorted results
     * @param results - array of results from all text search adapters
     * @param rankFn - function that updates results scores
     * based on more relevance
     */
    sortResults(results, rankFn) {
        return rankFn(results.sort((a, b) => -b.getLabel().localeCompare(a.getLabel()))).sort((result1, result2) => result1.getScore() - result2.getScore());
    }
}
exports.default = TextSearchManager;
